/* eslint-disable */
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";
import { RectorTimeline } from "../components/subcomponents/RectorTimeline";
import { APPNAME, APPOWNER } from "../utils/utils.constants";
import { keyFacts as staticKeyFacts } from "../utils/utils.statiquedata";
import bigCover from "../assets/images/hero-image.png";
import { useState, useEffect } from "react";
import { apiGet } from "../utils/api";

const MISSION_PILLARS = [
  {
    title: "Excellence académique",
    text: "Des programmes rigoureux, ancrés dans la réalité de la Région des Grands Lacs et ouverts sur le monde.",
  },
  {
    title: "Recherche au service de la société",
    text: "Des centres de recherche et une gouvernance engagées pour répondre aux défis éducatifs, sociaux et institutionnels.",
  },
  {
    title: "Formation intégrale",
    text: "Former des professionnels et des leaders dotés de compétences scientifiques, éthiques et citoyennes.",
  },
];

export const About: React.FC = () => {
  const [keyFacts, setKeyFacts] = useState<KeysFacts[]>([]);
  const [rectors, setRectors] = useState<any[]>([]);

  useEffect(() => {
    apiGet("/key-facts", { activeOnly: "true" })
      .then((res) => setKeyFacts(res.rows || []))
      .catch(() => setKeyFacts(staticKeyFacts));
  }, []);

  useEffect(() => {
    apiGet("/rectors")
      .then((res) => setRectors(res.rows || []))
      .catch(() => setRectors([]));
  }, []);

  return (
    <>
      {/* <BreadcrumpComponent
        imageCover={bigCover}
        title={`À propos de l'${APPNAME}`}
        subtitle="Développer une approche d'enseignement scientifique et de la recherche répondant aux aspirations de la société, dans la Région des Grands Lacs."
      /> */}

      <div className="about-page padding-x is-layout-constrained">
        <section className="about-page__intro" aria-labelledby="about-mission-heading">
          <PageSectionHeader
            id="about-mission-heading"
            eyebrow="Notre mission"
            title="Une université chrétienne au service du développement régional"
            lead={
              <>
                {APPOWNER} est un établissement à caractère scientifique, culturel et professionnel,
                privé et agréé par le Gouvernement congolais. Nous formons des cadres capables de
                contribuer au progrès éducatif, économique et social de la Région des Grands Lacs.
              </>
            }
            align="center"
          />

          <ul className="about-page__pillars">
            {MISSION_PILLARS.map((item) => (
              <li key={item.title} className="about-page__pillar">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </li>
            ))}
          </ul>
        </section>

        <section className="about-page__stats" aria-labelledby="about-stats-heading">
          <div className="about-page__stats-inner">
            <PageSectionHeader
              id="about-stats-heading"
              className="about-page__stats-header"
              eyebrow="En chiffres"
              title="Informations clés"
              lead={
                <>
                  Chiffres et repères qui illustrent l&apos;ampleur et l&apos;engagement de {APPNAME}{" "}
                  au service de la communauté universitaire.
                </>
              }
              align="center"
              tone="dark"
            />

            <ul className="about-page__stats-grid">
              {keyFacts.map((fact) => (
                <li key={fact.title} className="about-page__stat-card">
                  <span className="about-page__stat-value">{fact.value}</span>
                  <span className="about-page__stat-label">
                    <div dangerouslySetInnerHTML={{ __html: fact.title }} className="about-page__stat-label" />
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="about-page__rectors" aria-labelledby="about-rectors-heading">
          <PageSectionHeader
            id="about-rectors-heading"
            eyebrow="Histoire et gouvernance"
            title="Succession des Recteurs"
            lead="Depuis sa création en 1985, l'ULPGL a été dirigée par des personnalités académiques d'exception qui ont marqué son développement et son rayonnement."
            align="center"
          />
          <RectorTimeline rectors={rectors} />
        </section>

        {/* <Organizer /> */}
      </div>
    </>
  );
};
